import { Route, Routes } from 'react-router';
import Home from './Home';
import Checkout from '../views/Checkout';
import PageNotFound from './PageNotFound';

function Router() {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path=":orderId/status" element={<Checkout />} />
      <Route path=":orderId/method" element={<Checkout />} />
      <Route path=":orderId/new-address" element={<Checkout />} />
      <Route path=":orderId" element={<Checkout />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default Router;
